/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { Breadcrumbs, Item } from "@adobe/react-spectrum";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import React from "react";
// import { Link as RouterLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

// Utils
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

export const breadCrumbsRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("BreadCrumbs")
);

function BreadCrumbsRenderer({ uischema, visible }: RendererProps) {
  const navigate = useNavigate();
  const spectrumProps = uischema.options?.spectrumProps;
  const style = uischema.options?.style;
  // let [items, setItems] = useState<{ [key: string]: string }[]>(uischema.options?.items);
  const items: { [key: string]: string }[] = uischema.options?.items;

  function navigateToTargetPath(key: any) {
    const item: { [key: string]: string } | undefined = items.find(
      (itemKey) => +itemKey.id === +key
    );
    if (item !== undefined) navigate(`${item.targetPath}`);
  }

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  /**
   * extract the content from the redux store
   * @param path
   * @returns the content
   */
  const getContent = (path: string) => {
    // get the content from redux store based on the path provided
    let content = useSelector((state: any) => get(state?.reduxState, path));
    // check if content is present in Store, if not then return the path
    if (!content) {
      content = path;
    }
    return content;
  };
  return (
    <Breadcrumbs
      onAction={(a) => navigateToTargetPath(a)}
      data-testid="custom-breadcrumbs"
      {...spectrumProps}
      UNSAFE_style={style}
      isHidden={!componentVisibility}
    >
      {items !== undefined &&
        items.map((f) => <Item key={f.id}>{getContent(f.label)}</Item>)}
    </Breadcrumbs>
  );
}

export default withJsonFormsLayoutProps(BreadCrumbsRenderer);
